(() => {
  const tokenPattern = /\s*\[PRE-ORDER\]\s*/gi;
  const judgeMeSelector = [
    '.jdgm-widget',
    '[class*="jdgm-"]',
    '[id*="jdgm-"]',
    '[data-judge-me]'
  ].join(',');

  const cleanValue = (value, trim) => {
    if (!value || !/\[PRE-ORDER\]/i.test(value)) return value;
    const cleaned = value
      .replace(tokenPattern, ' ')
      .replace(/ {2,}/g, ' ')
      .replace(/\s+([,.;:!?])/g, '$1');
    return trim ? cleaned.trim() : cleaned;
  };

  const cleanJudgeMeRoot = (root) => {
    const roots = [];

    if (root instanceof Element && root.matches(judgeMeSelector)) {
      roots.push(root);
    }

    if (root.querySelectorAll) {
      roots.push(...root.querySelectorAll(judgeMeSelector));
    }

    [...new Set(roots)].forEach((scope) => {
      const walker = document.createTreeWalker(
        scope,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parent = node.parentElement;
            if (!parent || parent.closest('script, style, noscript, textarea')) {
              return NodeFilter.FILTER_REJECT;
            }
            return /\[PRE-ORDER\]/i.test(node.nodeValue || '')
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_REJECT;
          }
        }
      );

      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        node.nodeValue = cleanValue(node.nodeValue || '', false);
      });

      scope
        .querySelectorAll('[aria-label], [title], [data-product-title]')
        .forEach((element) => {
          ['aria-label', 'title', 'data-product-title'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            const cleaned = cleanValue(value, true);
            if (cleaned !== value) element.setAttribute(attribute, cleaned);
          });
        });
    });
  };

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      cleanJudgeMeRoot(document);
    });
  };

  cleanJudgeMeRoot(document);

  const isJudgeMeNode = (node) => {
    if (node instanceof Element) {
      return node.matches(judgeMeSelector) ||
        Boolean(node.closest(judgeMeSelector)) ||
        Boolean(node.querySelector(judgeMeSelector));
    }

    return node.nodeType === Node.TEXT_NODE &&
      Boolean(node.parentElement?.closest(judgeMeSelector));
  };

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      if (mutation.type === 'characterData') {
        return isJudgeMeNode(mutation.target) &&
          /\[PRE-ORDER\]/i.test(mutation.target.nodeValue || '');
      }

      if (mutation.type === 'attributes') {
        return isJudgeMeNode(mutation.target) &&
          /\[PRE-ORDER\]/i.test(
            mutation.target.getAttribute(mutation.attributeName) || ''
          );
      }

      return Array.from(mutation.addedNodes).some(isJudgeMeNode);
    });

    if (relevant) schedule();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label', 'title', 'data-product-title']
  });
})();